////////////////////////////////////////////////////////////////////////////////
// When
////////////////////////////////////////////////////////////////////////////////

class When extends Utilities {

	constructor(classmap, rules) {

    super()

    this.extend('when')
    this.extend('check')

    this.cache = {}
		this.classmap = classmap

    if ( typeof rules !== 'undefined' && typeof rules == 'function') {
      this.rules = rules
    }

		// this.eventClasses = {
		// 	inview : ['inview'],
		// 	devices : ['chrome', 'ie', 'firefox', 'safari', 'opera']
		// }
    //
		// this.eventsCache = {}
    //
		// this.eventGroups = {
		// 	devices     : ['desktop', 'tablet', 'mobile'],
		// 	events      : ['scroll', 'resize'],
		// 	mutations   : ['arrives', 'leaves', 'inview'],
		// 	animations  : ['animation-end', 'animation-start', 'animation-iteration'],
		// 	transitions : ['transition-end']
		// }
    //
		// this.allEvents = [].concat.apply([], Object.values(this.eventGroups))

    // Setup a timer
    this.timeout = null;
    window.addEventListener('resize',  () => {this.trigger()}, false);
    window.addEventListener('scroll',  () => {this.trigger()}, false);
    window.addEventListener('orientationchange',  () => {this.trigger()}, false);
    dom.ready( () => {this.trigger()})

  }

	// _events(setting) {
  //
	// 	let supportedEvents = []
  //
	// 	setting = setting instanceof Array ? setting : setting.split(' ')
  //
	// 	setting.forEach(event => {
	// 		if ( this.allEvents.includes(event) ) {
	// 			supportedEvents = [...supportedEvents, event]
	// 		}
	// 	})
  //
	// 	return supportedEvents
  //
	// }

	trigger(event) {

    if ( !this.timeout ) {
      this.timeout = setTimeout(() => {
        this.timeout = null;

				let target = typeof event !== 'undefined' ? event.target : false

        Object.entries(this.cache).forEach(([classname, methods]) => {
          methods.forEach(type => {
            let _class = this.classmap[classname]
            if ( typeof this.rules !== 'undefined' && typeof type.rules !== 'undefined' ) {
              if ( this.rules(type.rules, type.arguments) === true) {
                _class.class[_class.method].apply(_class.class, target ? [...type.arguments, target] : type.arguments)
              }
            } else {
              _class.class[_class.method].apply(_class.class, target ? [...type.arguments, target] : type.arguments)
            }
          })
        })
      }, 66);
    }

	}

	/** ==========================================================================
	 * When
	 * ===========================================================================
	 * Event listeners are added for each set of properties passed
	 */
  when(...settings) {

    // This will check to see if any of the parameters pased into this 'when'
    // method exist in the class map. If it does, we know to cache these settings.
    let classIsSupported = Object.keys(this.classmap).some(r=> settings.filter(item => typeof item == 'string').includes(r))

    if ( classIsSupported ) {

      // Filter out all the strings that match a supported class name.
      // Remove this string from the settings
      let classes = Object.values(settings).filter((classname, index) => {
        if (typeof classname == 'string' && Object.keys(this.classmap).includes(classname)) {
          settings.splice(index, 1)
          return true
        }
      })

      // Push all other setting parameters into the global cache object for this class
      classes.forEach(classname => {
        if ( !(classname in this.cache) ) {
          this.cache[classname] = []
        }
        this.cache[classname].push({ arguments : settings })
      })

      // A 'rules' method can also be chained to this 'when' method. These are
      // specific rules for the when class, not to be passed through to the event.
      return {
        rules : (...rules) => {

          let defaultRules = { global : false }

          // Combine the default rules with any other rules passed in the the
          // chained rules method. These get cached as a seperate property in the
          // class array.
          classes.forEach(classname => {
            this.cache[classname][this.cache[classname].length-1]['rules'] = Object.assign({}, defaultRules, ...rules)
          })

        }
      }

    }

    console.log(this.cache)




    // this.cache.push(settings)
    // console.log(Object.keys(this.classmap))
    // console.log(settings.filter(item => typeof item == 'string'))

    // this.manage(settings, {
    //   element : (setting) => { options['target'] = setting },
    //   function : (setting) => { options['callback'] = setting },
    //   object : (setting) => { Object.assign({}, options, setting) }
    // })


  }

	/** ==========================================================================
	 * Check
	 * ===========================================================================
	 * Checkers are only ran once
	 */
	check(...settings) {

		console.log(settings)

		// let events = []
		// let element = null
		// let callback = null
		// let handlers = {}
    //
		// this.manage(settings, {
		// 	function : (setting) => { callback = setting },
		// 	string   : (setting) => { events = this._events(setting) },
		// 	element  : (setting) => { element = setting },
		// 	object   : (setting) => { handlers = setting }
		// })
    //
		// Object.keys(handlers).forEach(key => {
    //
		// 	let _classname = Object.entries(this.classmap).find(_class => _class[1]['events'].includes(key))[1]
    //
		// 	if ( typeof this.eventsCache[key] == 'undefined' ) {
		// 		this.eventsCache[key] = new _classname.classname()
		// 	}
    //
		// 	this.eventsCache[key][_classname.methodName](element, handlers[key], key, 'check')
		// })

	}

}

// $('header').check({
// 	inview : (event, response) => {
// 		console.log(event, 'header is inview', response)
// 	}
// })
